function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { MediaContext } from 'react-media-query-hoc';
import { formatPrice } from '@domain-group/fe-allhomes-library';
import { Heading, Separator } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesTabbedPanel from '@domain-group/fe-co-allhomes-tabbed-panel';
import SuburbArticles from './components/suburb-articles';
import MedianSales from './components/median-sales';
import SuburbSummary from './components/suburb-summary';
import UnimprovedValue from './components/unimproved-value';
import CtaCard from './components/cta-card';
import commonPropTypes, { commonDefaultProps } from './common-props';
import * as styles from './allhomes-listing-suburb-stats.style';

/*
  layout prop can be:
  'default' - a vertical appearance with line graphs at the top and suburb stats
  'tabbed' - a compact appearance with median sales line graph and suburb stats in two tabs
*/
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingSuburbStats = _ref => {
  var title = _ref.title,
    description = _ref.description,
    medianStatistics = _ref.medianStatistics,
    medianPriceData = _ref.medianPriceData,
    unimprovedValues = _ref.unimprovedValues,
    suburbName = _ref.suburbName,
    population = _ref.population,
    averageAge = _ref.averageAge,
    occupancyData = _ref.occupancyData,
    profileData = _ref.profileData,
    onMedianSalesTabClick = _ref.onMedianSalesTabClick,
    onUVClick = _ref.onUVClick,
    onViewMoreInfoClick = _ref.onViewMoreInfoClick,
    disableAnimation = _ref.disableAnimation,
    suburbInfoLink = _ref.suburbInfoLink,
    articles = _ref.articles,
    showSuburbInfoLink = _ref.showSuburbInfoLink,
    suppressArticleLinks = _ref.suppressArticleLinks,
    layout = _ref.layout,
    underline = _ref.underline;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    smallTablet = _useContext.smallTablet;
  // Colours need to be resolved only during client-side render.
  var _useState = useState({
      resolved: false,
      uvRoundelColour: '#000'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    colours = _useState2[0],
    setColours = _useState2[1];
  useEffect(() => {
    if (!colours.resolved) {
      setColours({
        resolved: true,
        uvRoundelColour: styles.uvRoundelColour()
      });
    }
  }, [colours.resolved]);
  var updateSelectedTab = selectedTab => {
    if (selectedTab.id === 'median') {
      onMedianSalesTabClick();
    } else {
      onUVClick();
    }
  };
  var renderMedianStatisticsPanel = _ref2 => {
    var activePanel = _ref2.activePanel;
    return ___EmotionJSX("div", {
      css: styles.panel
    }, ___EmotionJSX(MedianSales, {
      key: activePanel,
      medianPriceData: medianPriceData,
      medianStatistics: medianStatistics,
      disableAnimation: disableAnimation,
      height: styles.lineGraphHeight
    }));
  };
  var renderUnimprovedValuesPanel = _ref3 => {
    var activePanel = _ref3.activePanel;
    return ___EmotionJSX("div", {
      css: styles.panel
    }, ___EmotionJSX("div", {
      css: styles.legend
    }, ___EmotionJSX("div", {
      css: styles.legendLabel
    }, "Unimproved value for ", suburbName), ___EmotionJSX("div", {
      css: styles.legendValue
    }, ___EmotionJSX("div", {
      css: styles.roundel({
        colour: colours.uvRoundelColour
      })
    }), ___EmotionJSX("div", null, "$", formatPrice(unimprovedValues[0].value)))), ___EmotionJSX(UnimprovedValue, {
      key: activePanel,
      unimprovedValues: unimprovedValues,
      disableAnimation: disableAnimation,
      height: styles.lineGraphHeight
    }));
  };
  var renderSuburbStatsPanel = _ref4 => {
    var activePanel = _ref4.activePanel;
    return ___EmotionJSX(SuburbSummary, {
      suburbName: suburbName,
      population: population,
      profileData: profileData,
      occupancyData: occupancyData,
      averageAge: averageAge,
      suburbInfoLink: suburbInfoLink,
      layout: layout === 'tabbed' ? 'no-title' : 'default',
      key: activePanel
    });
  };
  var hasMedianStatisticsData = medianStatistics || !isEmpty(medianPriceData);
  var hasUnimprovedValuesData = !isEmpty(unimprovedValues);
  var panels = [hasMedianStatisticsData && {
    tab: {
      id: 'median',
      label: "Median sales"
    },
    content: renderMedianStatisticsPanel
  }, !isEmpty(unimprovedValues) && {
    tab: {
      id: 'unimproved',
      label: 'Unimproved value'
    },
    content: renderUnimprovedValuesPanel
  }].filter(each => each);
  var hasPanels = panels.some(each => each);
  var hasCharts = averageAge || population || profileData || occupancyData;
  var isDefault = layout === 'default';
  var renderTabbedView = () => ___EmotionJSX("div", {
    css: styles.sectionContainer
  }, ___EmotionJSX(AllhomesTabbedPanel, {
    css: styles.tabbedPanel,
    tabWrapper: ___EmotionJSX("div", {
      css: styles.tabWrapper
    }),
    panels: [...(hasCharts ? [{
      tab: {
        id: 'summary',
        label: 'Summary'
      },
      content: renderSuburbStatsPanel
    }] : []), ...(hasMedianStatisticsData ? [{
      tab: {
        id: 'median',
        label: 'Median sales'
      },
      content: renderMedianStatisticsPanel
    }] : []), ...(hasUnimprovedValuesData ? [{
      tab: {
        id: 'uv',
        label: 'Unimproved value'
      },
      content: renderUnimprovedValuesPanel
    }] : [])],
    onTabClick: updateSelectedTab,
    type: "css",
    underline: underline
  }));
  var renderDefaultView = () => ___EmotionJSX("div", {
    css: styles.sectionContainer
  }, suppressArticleLinks || !isDefault || (articles === null || articles === void 0 ? void 0 : articles.length) > 0 && ___EmotionJSX(SuburbArticles, {
    layout: smallTablet ? 'two-row' : 'row',
    articles: articles,
    suburbName: suburbName
  }), hasCharts && ___EmotionJSX("div", {
    css: styles.chartContainer
  }, hasPanels && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AllhomesTabbedPanel, {
    css: styles.tabbedPanel,
    tabWrapper: ___EmotionJSX("div", {
      css: styles.tabWrapper
    }),
    panels: panels,
    onTabClick: updateSelectedTab,
    type: "css",
    underline: underline
  }), mobile && ___EmotionJSX(Separator, null)), ___EmotionJSX(SuburbSummary, {
    suburbName: suburbName,
    population: population,
    profileData: profileData,
    occupancyData: occupancyData,
    averageAge: averageAge,
    suburbInfoLink: suburbInfoLink,
    layout: layout === 'tabbed' ? 'no-title' : 'default'
  })), showSuburbInfoLink && ___EmotionJSX("div", {
    css: styles.ctaCard
  }, ___EmotionJSX(CtaCard, {
    appearance: mobile ? 'vertical' : 'horizontal',
    suburbName: suburbName,
    suburbInfoLink: suburbInfoLink,
    onViewMoreInfoClick: onViewMoreInfoClick
  })));
  return ___EmotionJSX("div", {
    css: styles.suburbStatsFull
  }, ___EmotionJSX(Heading, {
    css: styles.title,
    title: title || isDefault && 'Suburb and property insights' || "".concat(suburbName, " suburb information"),
    subtitle: description || !isDefault && 'A little bit about who lives locally, as provided by government census data'
  }), !isDefault && renderTabbedView(), isDefault && renderDefaultView());
};
AllhomesListingSuburbStats.propTypes = _objectSpread({}, commonPropTypes);
AllhomesListingSuburbStats.defaultProps = _objectSpread(_objectSpread({}, commonDefaultProps), {}, {
  onMedianSalesTabClick: () => {},
  onUVClick: () => {},
  showSuburbInfoLink: true,
  layout: 'default'
});
export default AllhomesListingSuburbStats;